import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 29 28",
  "content": "<symbol viewBox=\"0 0 29 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-account\">\n<circle cx=\"14.5\" cy=\"14\" r=\"13.5\" stroke=\"#666666\" />\n<path d=\"M12.8456 19.625C10.0487 19.625 7.64914 18.674 6.625 16.25\" stroke=\"#666666\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol